module.exports = __webpack_public_path__ + "img/part11.0cb1adf6.png";